import { PageWrapper } from 'components/layout/PageWrapper/index.js';
import { TopBar } from 'components/layout/TopBar/index.js';
import { NavigationBar } from 'components/navigation/NavigationBar/index.js';
import type { TMenuItem } from 'components/navigation/NavMenuItem/index.js';
import { Outlet } from 'react-router';
import { getMultiModalConfig } from 'shared/utils/multiModalConfig.js';

import { useMainLayoutEffects } from './MainLayout.effects.js';

export interface MainLayoutProps {
  navigationItems: TMenuItem[];
}

export const MainLayout = ({ navigationItems }: MainLayoutProps) => {
  const { toggleNav, isNavOpen } = useMainLayoutEffects();

  return (
    <>
      {!getMultiModalConfig()?.hideHeader && <TopBar toggleNav={toggleNav} />}
      <NavigationBar isNavOpen={isNavOpen} menuButtons={navigationItems} />
      <PageWrapper>
        <Outlet />
      </PageWrapper>
    </>
  );
};
